import React from "react";

// Hafif markdown önizleme — [GÖRSEL-N] işaretçilerinin YERİNDE üretilen görsel gösterilir.
// İçerik Önerileri listesi ve İçerik Detay sayfası tarafından paylaşılır.
export function WriterMd({ text, images }: { text: string; images?: Record<string, { url: string; alt: string }> }) {
  const imgFor = (n: string) => images?.[`[GÖRSEL-${n}]`];
  const inline = (s: string) => s.split(/(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\)|\[GÖRSEL-\d+\])/g).map((p, j) => {
    const g = p.match(/^\[GÖRSEL-(\d+)\]$/);
    if (g) {
      const im = imgFor(g[1]);
      if (im) return <img key={j} src={im.url} alt={im.alt} loading="lazy" className="rounded-lg my-2 max-w-full" />;
      return <span key={j} className="inline-block px-2 py-0.5 rounded text-[11px] font-semibold" style={{ background: "rgba(139,92,246,0.12)", color: "#d42b29" }}>🖼️ GÖRSEL-{g[1]}</span>;
    }
    const b = p.match(/^\*\*(.+)\*\*$/); if (b) return <strong key={j}>{b[1]}</strong>;
    const a = p.match(/^\[([^\]]+)\]\(([^)]+)\)$/); if (a) return <a key={j} href={a[2]} target="_blank" rel="noopener noreferrer" className="underline decoration-dotted" style={{ color: "#b12220" }}>{a[1]}</a>;
    return p;
  });
  const lines = text.split("\n"); const blocks: React.ReactNode[] = []; let i = 0, key = 0;
  while (i < lines.length) {
    const line = lines[i];
    // Kendi satırında duran görsel işaretçisi → görseli blok olarak yerinde göster
    const soloImg = line.trim().match(/^\[GÖRSEL-(\d+)\]$/);
    if (soloImg) {
      const im = imgFor(soloImg[1]);
      blocks.push(im
        ? <a key={key++} href={im.url} target="_blank" rel="noopener noreferrer" title="Yeni sekmede aç"><img src={im.url} alt={im.alt} loading="lazy" className="rounded-lg my-3 max-w-full" /></a>
        : <div key={key++} className="my-2"><span className="inline-block px-2 py-0.5 rounded text-[11px] font-semibold" style={{ background: "rgba(139,92,246,0.12)", color: "#d42b29" }}>🖼️ GÖRSEL-{soloImg[1]}</span></div>);
      i++; continue;
    }
    if (/^\s*\|.*\|\s*$/.test(line)) {
      const rows: string[][] = [];
      while (i < lines.length && /^\s*\|.*\|\s*$/.test(lines[i])) {
        const cells = lines[i].trim().replace(/^\||\|$/g, "").split("|").map((c) => c.trim());
        if (!cells.every((c) => /^:?-{2,}:?$/.test(c) || c === "")) rows.push(cells);
        i++;
      }
      if (rows.length) {
        const [h, ...body] = rows;
        blocks.push(<div key={key++} className="overflow-x-auto my-3"><table className="text-xs border-collapse w-full">
          <thead><tr>{h.map((c, j) => <th key={j} className="border px-2.5 py-1.5 text-left font-semibold" style={{ borderColor: "rgba(0,0,0,0.12)", background: "rgba(0,0,0,0.035)" }}>{inline(c)}</th>)}</tr></thead>
          <tbody>{body.map((r, ri) => <tr key={ri}>{r.map((c, j) => <td key={j} className="border px-2.5 py-1.5" style={{ borderColor: "rgba(0,0,0,0.08)" }}>{inline(c)}</td>)}</tr>)}</tbody>
        </table></div>);
      }
      continue;
    }
    const h = line.match(/^(#{1,4})\s+(.*)/);
    if (h) {
      // GERÇEK başlık etiketleri (h1-h4) — HTML çıktısıyla birebir aynı hiyerarşi görünsün
      const L = h[1].length;
      const cls = L === 1 ? "text-2xl font-bold mt-5 mb-1" : L === 2 ? "text-xl font-bold mt-5 mb-1" : L === 3 ? "text-base font-semibold mt-3" : "text-sm font-semibold mt-2";
      blocks.push(React.createElement(`h${L}`, { key: key++, className: cls }, inline(h[2])));
      i++; continue;
    }
    if (/^\s*[-*]\s+/.test(line)) { blocks.push(<div key={key++} className="pl-4">• {inline(line.replace(/^\s*[-*]\s+/, ""))}</div>); i++; continue; }
    if (line.trim()) blocks.push(<p key={key++}>{inline(line)}</p>);
    i++;
  }
  return <div className="text-sm leading-relaxed space-y-2">{blocks}</div>;
}
